import React,{Component} from 'react'
import {Row,Col,Form,Input,Button,Icon,message} from 'antd'
import {Redirect} from 'react-router-dom'
import userUtils from '../../utills/userUtils'
import './login.less'
import {reqLogin} from '../../api'
const Item = Form.Item
class Login extends Component {
    handleSubmit = (event) => {
        // 阻止事件的默认行为
        event.preventDefault()

        // 对所有表单字段进行检验
        this.props.form.validateFields(async (err, values) => {
            // 检验成功
            if (!err) {
                // console.log('提交登录的ajax请求', values)
                // 请求登录
                const {username, password} = values
                const result = await reqLogin(username, password)
                if (result.code===200) { // 登录成功
                    // 提示登录成功
                    message.success('登录成功')
                    userUtils.doLogin(result.data)

                    // 跳转到管理界面 (不需要再回退回到登录)
                    //this.props.history.replace('/')

                } else { // 登录失败
                    // 提示错误信息
                    message.error(result.message)
                }

            } else {
                console.log('检验失败!')
            }
        });
    }
    componentDidMount() {
        userUtils.checkLogin()
    }
    render () {
        // 如果用户已经登录, 自动跳转到管理界面
        //userUtils.checkLogin()
        const { getFieldDecorator} = this.props.form;
        return (
            <div className='login'>
                <Row style={{height:'100%'}}>
                    <Col span={12} className='login-left'>
                        <div className='logo-box'>
                            <div className="login-left-logo">
                            </div>
                            <div className="login-left-bank">
                                赣ICP备20005970号-1
                            </div>
                        </div>

                    </Col>
                    <Col span={12} className='login-right'>
                        <div className='login-content'>
                            <h3>欢迎登录！</h3>
                            <h2>赣州国际陆运港-客户企业管理系统</h2>
                            <Form onSubmit={this.handleSubmit} className="login-form">
                                <Item>
                                    {getFieldDecorator('username', {
                                        rules: [{ required: true, message: '请输入用户名' }]
                                    })(
                                        <Input
                                            prefix={<Icon type="user" className="login-icon"  />}
                                            placeholder="请输入用户名"
                                        />
                                    )}
                                </Item>
                                <Form.Item>
                                    {getFieldDecorator('password', {
                                        rules: [{ required: true, message: '请输入密码' }]
                                    })(
                                        <Input
                                            prefix={<Icon type="lock" className="login-icon" />}
                                            type="password"
                                            placeholder="请输入密码"
                                        />
                                    )
                                    }
                                </Form.Item>
                                {/*<Form.Item>
                                    <Row gutter={8}>
                                        <Col span={16}>
                                            {getFieldDecorator('password', {
                                                rules: [
                                                    {
                                                        validator: this.validatePwd
                                                    }
                                                ]
                                            })(
                                                <Input
                                                    prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                                    placeholder="请输入验证码"
                                                />
                                            )
                                            }
                                        </Col>
                                        <Col span={8}>
                                            <Button>7364</Button>
                                        </Col>
                                    </Row>
                                </Form.Item>*/}
                                <Form.Item>
                                    <Button type="primary" htmlType="submit" className="login-form-button">
                                        登录
                                    </Button>
                                </Form.Item>
                            </Form>
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }
}
const WrapLogin = Form.create()(Login)
export default WrapLogin